import { useEffect, useState } from 'react';

const PRIVILEGE_SESSION_KEY = 'privileged_session_end_ms';

export const endCurrentPrivilegedSession = () => {
  window.sessionStorage.setItem(PRIVILEGE_SESSION_KEY, '0');
  // Manually dispatch the event to be seen in the same context/tab
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: PRIVILEGE_SESSION_KEY,
    })
  );
};

export const getCurrentPrivilegedSession = () => {
  const value = window.sessionStorage.getItem(PRIVILEGE_SESSION_KEY);
  if (!value) {
    return {
      endMs: 0,
      end: () => null,
      getIsActive: () => {
        return false;
      },
    };
  }
  const endMs = parseInt(value);
  return {
    endMs,
    getIsActive: () => {
      return Date.now() < endMs;
    },
    end: () => {
      endCurrentPrivilegedSession();
    },
  };
};

export const startCurrentPrivilegedSession = (durationMs: number) => {
  window.sessionStorage.setItem(
    PRIVILEGE_SESSION_KEY,
    (Date.now() + durationMs).toString()
  );
  // Manually dispatch the event to be seen in the same context/tab
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: PRIVILEGE_SESSION_KEY,
    })
  );
  return getCurrentPrivilegedSession();
};

export const useCurrentPrivilegedSession = () => {
  const [session, setSession] = useState(() => getCurrentPrivilegedSession());
  useEffect(() => {
    const listener = function (event: StorageEvent) {
      if (event.key !== PRIVILEGE_SESSION_KEY) {
        return;
      }
      setSession(getCurrentPrivilegedSession());
    };
    window.addEventListener('storage', listener);
    return () => {
      window.removeEventListener('storage', listener);
    };
  }, []);
  return session;
};
